import React, { memo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import CustomButton from './CustomButton';
import withRoutingProps from '../../hooks/withRoutingProps';
import useModalTracking from '../../hooks/useModalTracking';

const CustomModal = ({
  isOpen,
  name = undefined,
  modalTitle = undefined,
  closeClick,
  saveClick,
  modalClick = undefined,
  modalSize = 'sm',
  modalScrollable = false,
  modalBackDrop = undefined,
  isCentered = false,
  modalHeaderClassName = undefined,
  // Save Button
  isSaveButtonVisible = true,
  submitButtonName = 'Save',
  isCloseButtonVisible = true,
  closeButtonName = 'Close',
  submitButtonColor = 'secondary',
  isSaveButtonDisabled = false,
  saveButtonClassName = undefined,
  //
  modalOnOpened = undefined,
  modalOnClosed = undefined,
  modalClassName = undefined,
  modalStyle = undefined,
  modalKeyboard = undefined,
  bodyClassName = undefined,
  bodyStyle = undefined,
  extraFooterChildren = undefined,
  isFooterVisible = true,
  isHeaderVisible = true,
  children,
  isLightTheme
}) => {
  const tracking = useModalTracking(name);
  return (
    <Modal
      isOpen={isOpen}
      toggle={closeClick}
      backdrop={modalBackDrop}
      centered={isCentered}
      size={modalSize}
      scrollable={modalScrollable}
      className={` ${modalClassName || ''}`}
      backdropClassName={`${isLightTheme ? 'modal-backdrop-light' : 'modal-backdrop-dark'}`}
      style={modalStyle}
      keyboard={modalKeyboard}
      onOpened={() => {
        tracking.onOpened();
        modalOnOpened && modalOnOpened();
      }}
      onClosed={() => {
        tracking.onClosed();
        modalOnClosed && modalOnClosed();
      }}
      onClick={modalClick}
    >
      {isHeaderVisible && (
        <ModalHeader className={modalHeaderClassName}>
          {modalTitle}
          <CustomButton
            color={submitButtonColor}
            className="modal-close-button clickable"
            outline
            onClick={closeClick}
          >
            <span className="fa fa-times" onClick={closeClick} />
          </CustomButton>
        </ModalHeader>
      )}
      <ModalBody className={bodyClassName} style={bodyStyle}>
        {children}
      </ModalBody>
      {isFooterVisible && (
        <ModalFooter>
          {extraFooterChildren ? extraFooterChildren : undefined}
          {isSaveButtonVisible ? (
            <CustomButton
              outline
              type="submit"
              color="primary"
              className={saveButtonClassName}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                if (saveClick) {
                  saveClick();
                }
              }}
            >
              {submitButtonName}
            </CustomButton>
          ) : (
            ''
          )}
          {isCloseButtonVisible && (
            <CustomButton outline type="reset" color="secondary" className="mr-2" onClick={closeClick}>
              {closeButtonName}
            </CustomButton>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

CustomModal.displayName = 'CustomModal';
export default memo(withRoutingProps(CustomModal));
